import localStorageUtil from './localStorageUtil';

export function getUserInfo() {
  return localStorageUtil.getItem('tegUser');
}
